/**
 * Фирменные цвета и типографика брендбука Idealitika
 * (ассеты маркетолога / public/brand/logo).
 */
export const BRANDBOOK = {
  /** Тёмный фон */
  ink: "#06080B",
  /** Светлый нейтральный фон */
  mist: "#F5F5F7",
  /** Акцент интерактива (hover / active меню) */
  red: "#D6002E",
  /** Светлый розовый подложка */
  blush: "#FFF0F2",
  white: "#FFFFFF",
  /** Фирменный красный (заголовки, акцент в тексте) */
  rose: "#E11D48",
  /** Вторичный текст */
  textMuted: "#7C7C80",
  /** Основной текст */
  text: "#1D1D1F",

  fontFamily: 'Arial, Helvetica, sans-serif',

  /** Лого в шапке (svg) */
  headerLogoWidthPx: 190,
  headerLogoWidthLgPx: 300,

  submenuRadiusPx: 20,

  nav: {
    fontSizePx: 14,
    weight: 400,
    weightActive: 700,
  },

  type: {
    overlinePx: 20,
    h1Px: 40,
    h2Px: 30,
    h3Px: 18,
    bodyPx: 18,
    bodyLargePx: 22,
    buttonPx: 16,
    valuesTitlePx: 30,
    valuesBodyPx: 18,
  },
} as const;
